<template>
  <v-form v-model="valid" ref="form" lazy-validation>
    <v-layout row wrap>
      <v-flex xs12>

        <v-autocomplete
        v-if="companhia.length > 1"
        label="Unidade"
        :items="companhia"
        item-text="name"
        return-object
        v-model="selectUnidade"
        max-height="400"
        hint="Escolha a unidade que deseja cadastrar o projeto"
        persistent-hint
        ></v-autocomplete>

        <v-autocomplete
        v-if="turma.length > 0"
        label="Turmas"
        :items="turma"
        :rules="[v => !!v || 'Turma é obrigatório']"
        item-text="name"
        return-object
        v-model="selectTurma"
        @blur="getPadrao"
        max-height="400"
        hint="Escolha a turma que o projeto será cadastrado"
        persistent-hint
        ></v-autocomplete>
        <v-layout align-center justify-center row fill-height>
          <v-progress-circular
            indeterminate
            align-center
            :size="50"
            style="text-align: center"
            color="primary"
            v-if="waiting"
          ></v-progress-circular>
        </v-layout>

      </v-flex>
      <v-flex xs12 v-if="!waiting">
        <v-flex xs12 mt-2 v-if="!isMakerlab">
          <h2 class="mb-1">Deseja utilizar um projeto padrão?</h2>
          <v-switch v-model="padrao" color="primary" label="Utilizar padrão"></v-switch>
        </v-flex>
        <v-flex xs12 v-if="isMakerlab">
          <h2 class="mb-1">Escolha o modelo de projeto abaixo</h2>
        </v-flex>
        <v-flex xs12>
          <v-autocomplete
            label="Projeto padrão"
            :items="padroes"
            :disabled="!padrao"
            :rules="[v => !!v || 'Programa é obrigatório']"
            item-text="name"
            item-value="name"
            v-model="result"
            return-object
            max-height="400"
            @input="newName()"
            hint="Escolha o projeto padrão como base"
            persistent-hint
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-if="showNext"
            label="Nome"
            v-model="novoNome"
            required
            disabled
          ></v-text-field>
          <v-select
            v-if="showNext && !isMediador "
            label="*Mediador"
            :items="mediador"
            item-text="username"
            :rules="[ value => value.length >= 1 || 'Mediador é obrigatório.']"
            item-value="username"
            v-model="result.moderador"
            max-height="400"
            hint="Escolha o responsável pelo projeto"
            persistent-hint
            required
          ></v-select>
            <v-textarea
              v-if="showNext"
              name="Descricao"
              v-model="novoDescrition"
              label="Descrição"
              :counter="1200"
              maxlength="1200"
              disabled
            ></v-textarea>
            <v-textarea
              v-if="showNext"
              name="Objetivo"
              v-model="novoObjetivo"
              label="Objetivo"
              :counter="1200"
              maxlength="1200"
              disabled
            ></v-textarea>

        </v-flex>

        <v-flex xs12>
          <v-spacer></v-spacer>
          <v-layout align-center justify-end row fill-height>
            <div class="mt-5">
              <v-btn color="primary" @click.native="proximo">Continuar</v-btn>
            </div>
          </v-layout>
        </v-flex>
        <v-snackbar v-model="snackbar" bottom color="red">Escolha um projeto padrão.</v-snackbar>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import api from '@/api';
export default {
  components: {},
  props: [
    'step1Data',
    'unidade'
  ],
  data () {
    return {
      projetoData: {},
      novoNome: '',
      novoDescrition: '',
      novoObjetivo: '',
      showNext: false,
      result: {},
      padroes: [],
      mediador: [],
      moderador: {},
      padrao: false,
      snackbar: false,
      refreshDOM: true,
      valid: true,
      titulo: true,
      waiting: true,
      turma: {},
      cont: 0,
      companhia: {},
      unidades: {},
      selectTurma: [],
      selectUnidade: [],
      step1Data: [],
      menu2: false
    };
  },
  mounted () {
    // api.request('GET', 'modeloProjetos/').then(response => {
    //   this.padroes = response.data;
    // })
    api.request('GET', 'unidade/').then(resp => {
      this.unidades = resp.data
      this.filtroUnidade()
    })
    if (this.isMakerlab) {
      this.padrao = true;
    }
    this.$watch('selectTurma', function () {
      this.getPadrao(this.selectTurma)
    })
    this.$watch('selectUnidade', function () {
      this.getTurma(this.selectUnidade)
    })
    this.$watch('step1Data', () => {
      this.result = this.step1Data
    })
  },
  computed: {
    isMakerlab () {
      return this.$store.state.company.makerlab;
    },
    isMediador () {
      this.seletor()
      return this.$store.state.selectedRole.name === 'Mediador'
    }
  },
  methods: {
    proximo () {
      if (this.padrao) {
        if (this.result.id === undefined) {
          this.snackbar = true
        } else {
          this.result.turma = this.selectTurma.slug
          this.result.name = this.novoNome
          this.result.unidade = this.selectUnidade.slug
          this.$emit('dadoUnidade', this.selectUnidade)
          this.$emit('dados1', this.result);
          this.$emit('next');
        }
      } else {
        this.$emit('dadoUnidade', this.selectUnidade)
        this.$emit('next')
      }
    },
    filtroUnidade () {
      this.companhia = this.unidades.filter(value => {
        return value.company === this.$store.state.company.id
      })
      if (this.companhia.length < 2) {
        this.getTurma(this.companhia)
      } else {
        this.waiting = false
      }
    },
    seletor () {
      console.log('seletor')
      this.result.moderador = this.$store.state.user.username
      console.log('result', this.result)
    },
    getTurma (companhia) {
      if (companhia.length < 2) {
        companhia = companhia[0]
        this.selectUnidade = companhia
      }
      api.request('GET', 'turmas/?unidade__slug=' + companhia.slug).then(resp => {
        this.turma = resp.data
        this.waiting = false
      })
    },
    getPadrao (turma) {
      var semSpace = turma.ano.replace(/ /g, '+')
      var selectSlug = this.selectUnidade.programa.toString()

      selectSlug = selectSlug.replace(/,/g, '%2C')
      api.request('GET', '/modeloProjetos/?name=&ano__name=' + semSpace + '&programas__slug__in=' + selectSlug).then(response => {
        this.padroes = response.data
      })
    },
    modelopadrao () {
      this.padrao = true;
    },
    modelonovo () {
      this.padrao = false;
    },
    newName () {
      this.mediador = this.selectUnidade.mediadores
      this.novoNome = this.result.name + ' ' + this.selectTurma.name + ' ' + this.selectTurma.dt_inicio.slice(0, 4)
      // this.result.name = this.novoNome
      this.novoDescrition = this.result.description
      this.result.description = this.novoDescrition
      this.novoObjetivo = this.result.objetivo
      this.result.objetivo = this.novoObjetivo
      this.showNext = true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Projetos/CadastroSteps/Step1Lab.vue